import { trackCioEvent } from '../cio';
import { identifyUser } from '../identifyUser';
import { AnalyticsEvent } from '../types';

export type InsuranceSendLinkEventProperties = {
  primaryContactEmail: string;
  primaryContactPhoneNumber: string;
};

export function trackInsuranceSendLink(properties: InsuranceSendLinkEventProperties) {
  void identifyUser(properties.primaryContactEmail, {
    primaryContactEmail: properties.primaryContactEmail,
    primaryContactPhoneNumber: properties.primaryContactPhoneNumber,
  });

  trackCioEvent(AnalyticsEvent.DTC_INSURANCE_SEND_LINK);
}
